import { LightshowState } from '../lightshow-state';
import { LightShowOperation } from './lightshow-operation';
import { ColorHelpers } from '../../_shared/color-helper';
import { FlashTypes } from '../operation-types';

export class SetColorOperation extends LightShowOperation {
  public color: string;
  public v2Duration: number;
  public v2FadeInDuration: number;
  public v2FadeOutDuration: number;

  constructor(position: number, fadeIn: number, color: string, v2Duration: number, v2FadeOut: number) {
    super();
    this.position = position;
    this.duration = fadeIn;
    this.color = color;
    this.flashType = FlashTypes.color;

    this.v2Duration = v2Duration;
    this.v2FadeInDuration = fadeIn;
    this.v2FadeOutDuration = v2FadeOut;
  }

  public toJson() {
    return [{ type: FlashTypes.color, duration: Math.round(this.duration) / 1000, time: Math.round(this.position), colors: [this.color], v2Duration: Math.round(this.v2Duration), v2FadeInDuration: Math.round(this.v2FadeInDuration), v2FadeOutDuration: Math.round(this.v2FadeOutDuration) }];
  }

  end(state: LightshowState): void {
    state.screenColor = this.color;
  }

  tick(state: LightshowState): void {
    const endColor = ColorHelpers.hexToColor(this.color) ?? ColorHelpers.blk;
    const startColor = ColorHelpers.hexToColor(state.screenColor) ?? ColorHelpers.blk;
    const factor = Math.min(1, (state.playbackPosition - this.position) / this.duration);

    state.screenColor = ColorHelpers.colorToHex({
      r: Math.round(startColor.r + (endColor.r - startColor.r) * factor),
      g: Math.round(startColor.g + (endColor.g - startColor.g) * factor),
      b: Math.round(startColor.b + (endColor.b - startColor.b) * factor)
    });
  }
  public wait () {}
}
